import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8v8h4","key":"svg-0"}]]

const IconLetterLSmall = createReactComponent('outline', 'letter-l-small', 'LetterLSmall', __iconNode);

export default IconLetterLSmall;